module.exports = __webpack_public_path__ + "media/img/avatars/projects/project-1-5668d4c5820d66ab771459193a59be3b.jpg";